import React from "react";
import { useParams } from "react-router-dom";
import AdminSettings from "./AdminSettings";
import AdminStatistics from "./AdminStatistics";

interface AdminRouteParams {
  adminSection: "statistics" | "settings";
}

export const AdminPage = () => {
  const { adminSection } = useParams<AdminRouteParams>();

  switch (adminSection) {
    case "settings":
      return <AdminSettings />;
    case "statistics":
      return <AdminStatistics />;
    default:
      // TODO add "page not found"
      return <></>;
  }
};

export default AdminPage;
